import React from 'react';
import { getBlogPosts } from '../data/blogPosts';
export function SitemapPage() {
  const posts = getBlogPosts();
  const sitemapXML = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">
  <url>
    <loc>https://crmkraft.de/</loc>
    <lastmod>2024-12-07</lastmod>
    <changefreq>weekly</changefreq>
    <priority>1.0</priority>
    <xhtml:link rel="alternate" hreflang="de" href="https://crmkraft.de/"/>
    <xhtml:link rel="alternate" hreflang="en" href="https://crmkraft.de/?lang=en"/>
  </url>
  <url>
    <loc>https://crmkraft.de/kostenlose-demo</loc>
    <lastmod>2024-12-08</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.95</priority>
    <xhtml:link rel="alternate" hreflang="de" href="https://crmkraft.de/kostenlose-demo"/>
    <xhtml:link rel="alternate" hreflang="en" href="https://crmkraft.de/kostenlose-demo?lang=en"/>
  </url>
  <url>
    <loc>https://crmkraft.de/about</loc>
    <lastmod>2024-12-07</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
    <xhtml:link rel="alternate" hreflang="de" href="https://crmkraft.de/about"/>
    <xhtml:link rel="alternate" hreflang="en" href="https://crmkraft.de/about?lang=en"/>
  </url>
  <url>
    <loc>https://crmkraft.de/blog</loc>
    <lastmod>2024-12-07</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
    <xhtml:link rel="alternate" hreflang="de" href="https://crmkraft.de/blog"/>
    <xhtml:link rel="alternate" hreflang="en" href="https://crmkraft.de/blog?lang=en"/>
  </url>
${posts.map(post => `  <url>
    <loc>https://crmkraft.de/blog/${post.slug}</loc>
    <lastmod>${post.publishedAt}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
    <xhtml:link rel="alternate" hreflang="de" href="https://crmkraft.de/blog/${post.slug}"/>
    <xhtml:link rel="alternate" hreflang="en" href="https://crmkraft.de/blog/${post.slug}?lang=en"/>
  </url>`).join('\n')}
  <url>
    <loc>https://crmkraft.de/impressum</loc>
    <lastmod>2024-12-07</lastmod>
    <changefreq>yearly</changefreq>
    <priority>0.3</priority>
  </url>
  <url>
    <loc>https://crmkraft.de/datenschutz</loc>
    <lastmod>2024-12-07</lastmod>
    <changefreq>yearly</changefreq>
    <priority>0.3</priority>
  </url>
</urlset>`;
  return <pre style={{
    margin: 0,
    padding: 0,
    fontFamily: 'monospace',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  }} data-id="element-694">
      {sitemapXML}
    </pre>;
}